<h5>
   <span>Community ISRI Score</span>
   <span
      ngbTooltip="This score reflects the average rating given by users on our platform, based on their
assessment of the company’s ethical and moral practices using the same IRI
framework."
      placement="top"
      [tooltipClass]="'tooltip_white_bg'"
      style="display: inline-block; cursor: pointer"
   >
      <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
   </span>
</h5>

<div class="rating_row">
   <div class="rating_row_top">
      <h4>
         <ng-container *ngIf="!isLoading; else loadingScore">
            {{ (communityData?.iri_score ?? 0) > 0 ? communityData.iri_score : '-' }}/<span>5</span>
            <small [ngClass]="getScoreClass(communityData?.score_classification)">
               {{ communityData?.score_classification || '' }}
            </small>
         </ng-container>
         <ng-template #loadingScore>
            <div class="skeleton-score"></div>
         </ng-template>
      </h4>
      <button class="btn__rate" (click)="openModal(iriModal)" *ngIf="!isSample">
         {{ hasExistingRatings ? "Update Rating" : "Rate" }}
      </button>
   </div>

   <div class="rating_row_bottom">
      <ng-container *ngIf="(communityData?.iri_score ?? 0) > 0; else noRatingMessage">
         <span class="rating_row_bottom_text">
            Based on ratings from {{ communityData?.user_count || 0 }} user<span *ngIf="communityData?.user_count > 1">s</span>
         </span>
         <br *ngIf="userAverageRating > 0" />
         <span class="rating_row_bottom_span" *ngIf="userAverageRating > 0">
            You have rated this stock as {{ userAverageRating }}/5
         </span>
      </ng-container>

      <ng-template #noRatingMessage>
         <span class="rating_row_bottom_text">
            No Community Score yet. Be the first to evaluate this stock through
            Islamic and ethical lenses.
         </span>
      </ng-template>
   </div>
</div>

<ng-template #iriModal let-modal>
   <div class="modal-header">
      <div>
         <h2>User ISRI Rating</h2>
         <p class="subheading">
            Help build investing world guided by Islamic values through your
            ratings
         </p>
      </div>
      <button
         type="button"
         class="close"
         aria-label="Close"
         (click)="modal.dismiss('Cross click')"
      >
         <span aria-hidden="true">&times;</span>
      </button>
   </div>

   <div class="modal-body">
      <h3>Core Islamic & Ethical Criteria</h3>

      <div class="criteria" *ngFor="let item of criteria">
         <div class="criteria-info">
            <h4>{{ item.title }}</h4>
            <p>{{ item.description }}</p>
         </div>
         <div class="criteria-slider">
            <div class="criteria_rating__row">
               <div style="width: 100%">
                  <div class="criteria_rating__text">
                     <span>0</span>
                     <span>5</span>
                  </div>

                  <div class="criteria_rating__button_row">
                     <button
                        *ngFor="let rating of ratings; index as i"
                        class="criteria_rating_button"
                        [class.active]="item.score >= i + 1"
                        (click)="setRating(item, i + 1)"
                     >
                        {{ i + 1 }}
                     </button>
                  </div>
               </div>
               <div class="circular-badge">
                  <svg class="progress-ring" width="46" height="46">
                     <circle class="ring-bg" cx="23" cy="23" r="21" />
                     <circle
                        class="ring-progress"
                        cx="23"
                        cy="23"
                        r="21"
                        [attr.stroke-dasharray]="circumference"
                        [attr.stroke-dashoffset]="getProgressOffset(item.score)"
                        [attr.stroke]="getStrokeColor(item.score)"
                     />
                  </svg>
                  <div class="circular_bar_text">
                     <span class="value-text">{{ item.score }}</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <div class="modal-footer">
      <button class="btn_cancel" (click)="openCancelConfirmation(modal)">
         Cancel
      </button>
      <!-- Add this new button for removing ratings -->
      <!-- Updated Remove Rating button -->
      <button
         class="btn_remove"
         *ngIf="hasExistingRatings"
         (click)="removeRatings(modal)"
         [disabled]="isRemoving"
      >
         <span *ngIf="!isRemoving">Remove Rating</span>
         <span *ngIf="isRemoving">
            <span
               class="spinner-border spinner-border-sm"
               role="status"
               aria-hidden="true"
            ></span>
            Removing...
         </span>
      </button>
      <!-- <button
         class="btn_save"
         [disabled]="!hasRatings() || isLoading"
         (click)="openSaveToDraftModal(modal)"
      >
         <span *ngIf="!isLoading">Save to Draft</span>
         <span *ngIf="isLoading">Saving...</span>
      </button> -->
      <button
         class="btn_submit"
         (click)="openThankyouModal(modal)"
         [disabled]="!allRatingsSelected() || isLoading"
      >
         Submit
      </button>
   </div>
</ng-template>

<!-- Add these at the bottom with your other ng-templates -->

<!-- Remove Confirmation Modal -->
<ng-template #removeConfirm let-modal>
   <div class="modal-body cancel_modal">
      <p>Are you sure you want to remove your rating?</p>
      <p>This action cannot be undone.</p>
      <div class="btn__group">
         <button class="btn__no" (click)="modal.dismiss()">No</button>
         <button class="btn__yes2" (click)="modal.close('confirm')">
            Yes, Remove
         </button>
      </div>
   </div>
</ng-template>

<!-- Remove Success Modal -->
<ng-template #removeSuccessModal let-modal>
   <div class="modal-body cancel_modal">
      <div class="text-center icon_thankyou">
         <img src="../../../../assets/icons/IconIRIRanking.svg" />
      </div>
      <p>Your rating has been successfully removed.</p>
      <div class="btn__group">
         <button class="btn__yes" (click)="modal.close('confirm')">OK</button>
      </div>
   </div>
</ng-template>

<ng-template #cancelConfirm let-modal>
   <div class="modal-body cancel_modal">
      <p>Are you sure you want to cancel?</p>
      <p>All progress made so far will be discarded.</p>
      <div class="btn__group">
         <button class="btn__no" (click)="modal.dismiss()">No</button>
         <button class="btn__yes" (click)="modal.close('confirm')">Yes</button>
      </div>
   </div>
</ng-template>

<ng-template #ThankyouModal let-modal>
   <div class="modal-body cancel_modal">
      <div class="text-center icon_thankyou">
         <img src="../../../../assets/icons/IconIRIRanking.svg" />
      </div>
      <p>Thank you for contributing to our ethical investment research.</p>
      <div class="btn__group">
         <button class="btn__yes" (click)="modal.close('confirm')">OK</button>
      </div>
   </div>
</ng-template>

<ng-template #SaveToDraftModal let-modal>
   <div class="modal-body cancel_modal">
      <p>
         Your changes have been saved. You can come back and complete this
         later.
      </p>
      <div class="btn__group">
         <button class="btn__yes" (click)="modal.close('confirm')">OK</button>
      </div>
   </div>
</ng-template>

<ng-template #SaveDraftErrorModal let-modal>
   <div class="modal-body cancel_modal">
      <p class="text-danger">
         Please rate at least one item before saving to draft.
      </p>

      <div class="btn__group">
         <button class="btn__error" (click)="modal.close('confirm')">OK</button>
      </div>
   </div>
</ng-template>
